import { rwPassengersData as passengersData } from '../../../entities/rw-passengers-data';

function getDocumentValidator(documentType: string) {
  switch (documentType) {
    case passengersData.config.documentTypes.ID:
      return {
        regex: /[0-9]{9}/,
        messagePath: 'id', // concatenated with validationMessagePath and validation field name like documentNumber
      };
    case passengersData.config.documentTypes.BIRTH_CERT:
      return {
        regex: /[0-9]{7,}\b/,
        messagePath: 'birthCertificate',
      };
    case passengersData.config.documentTypes.PASSPORT_KZ:
      return {
        regex: /N[0-9]{8}/,
        messagePath: 'passport',
      };
    default:
      return {
        regex: /.*/,
        messagePath: 'otherDocuments',
      };
  }
}

export function documentValidator(value: string, documentType: string) {
  const { regex, messagePath } = getDocumentValidator(documentType);
  return {
    messagePath,
    $valid: regex.test(value),
  };
}
